module.exports = __webpack_public_path__ + "img/code.025ed89e.png";